import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { FeatureSnapshot } from 'components/FeatureSnapshot';
import { StaticImage } from 'gatsby-plugin-image';
import { IconPieChart } from '@posthog/icons';
import * as React from 'react';
export default {
  getImage,
  GatsbyImage,
  FeatureSnapshot,
  StaticImage,
  IconPieChart,
  React
};